import {
  NEXT_PAGE,
  PREVIOUS_PAGE,
  SELECT_CATEGORY,
  SET_PAGE,
  TOGGLE_MODAL
} from '../actions/types';

const ui = (
  state = {
    activePage: 1,
    selectedCategory: {},
    showModal: false
  },
  action
) => {
  switch (action.type) {
    case NEXT_PAGE:
      return {
        ...state,
        activePage: state.activePage + 1
      };
    case PREVIOUS_PAGE:
      return {
        ...state,
        activePage: state.activePage - 1
      };
    case SELECT_CATEGORY:
      return {
        ...state,
        selectedCategory: action.category
      };
    case SET_PAGE:
      return {
        ...state,
        activePage: action.pageNum
      };
    case TOGGLE_MODAL:
      return {
        ...state,
        showModal: action.showModal || !state.showModal
      };
    default:
      return state;
  }
};

export default ui;
